<template>
    <b-modal
      v-model="visible"
      title="Create Report"
      @hidden="onModalClose"
      :no-close-on-backdrop="isLoading"
      :no-close-on-esc="isLoading"
      :hide-header-close="isLoading"
    >
      <div
        v-if="isLoading"
        class="d-flex justify-content-center align-items-center p-3"
        style="height: 100px;"
      >
        <Spinner
          style="width: 30px; height: 30px; color: #007bff; vertical-align: middle;"
        ></Spinner>
        <p class="ml-2 align-self-center">Scheduling report</p>
      </div>
  
      <div v-else>
        <p>
          The result may take time to create, do you want to schedule the execution and receive an email when you can download the execution?
        </p>
  
        <!-- Add Report Name Input -->
        <b-form-group
          label="Report name (max 100 characters)"
          label-for="report-name-input"
        >
          <b-form-input
            id="report-name-input"
            v-model="reportName"
            :disabled="isLoading"
            maxlength="100"
            placeholder="Enter report name"
          ></b-form-input>
          <small v-if="reportName.length > 0">
            {{ 100 - reportName.length }} characters remaining
          </small>
        </b-form-group>
      </div>
  
      <template #modal-footer>
        <b-button :disabled="isLoading || !reportName" variant="success" @click="submit"
          >Schedule execution</b-button
        >
        <b-button :disabled="isLoading" variant="danger" @click="cancel"
          >Cancel</b-button
        >
      </template>
    </b-modal>
  </template>
  
  <script>
  import Spinner from "@/components/Shared/Spinner/Spinner";
  export default {
    name: "ScheduleReportModal",
    components: { Spinner },
    props: {
      loading: { type: Boolean, required: false },
      show: {
        type: Boolean,
        required: true
      }
    },
    watch: {
      show(newVal) {
        this.visible = newVal;
        this.reportName = ''
      },
      loading(newVal) {
        this.isLoading = newVal;
      }
    },
    data() {
      return {
        isLoading: this.loading,
        visible: this.show,
        reportName: '' // Add this to track the report name
      };
    },
    methods: {
      submit() {
        this.$emit("submit", this.reportName); // Pass the report name when submitting
      },
      cancel() {
        this.$emit("cancel");
      },
      onModalClose() {
        this.$emit("cancel");
      }
    }
  };
  </script>
  